module.exports = __webpack_public_path__ + "img/traffic.55ff8f64.jpg";